import { parseToSafeJson } from '../../core/security'

function mediate(actor, payload, delegated) {
  delegated(data => {
    // we are discarding return value
    actor.call(void 0, parseToSafeJson(data))
  }, parseToSafeJson(payload))
}

export default function fronthubCommunicationApiFactory(fronthubInstance) {
  return {
    dispatchEvent(eventName, eventData) {
      ;(fronthubInstance.listeners[eventName] || []).forEach(listener =>
        listener.call(undefined, eventData),
      )
    },
    delegate(delegateName, param, actor = () => {}) {
      if (typeof param === 'function') {
        actor = param
        param = {}
      } else if (typeof param === 'undefined') {
        param = {}
      }
      if (
        Object.prototype.hasOwnProperty.call(
          fronthubInstance.delegates,
          delegateName,
        )
      ) {
        mediate(actor, param, fronthubInstance.delegates[delegateName])
      } else {
        // eslint-disable-next-line no-param-reassign
        fronthubInstance.deferredDelegates[delegateName] = [
          ...(fronthubInstance.deferredDelegates[delegateName] || []),
          [actor, param],
        ]
      }
    },
    registerDelegate(delegateName, delegate) {
      if (
        !Object.prototype.hasOwnProperty.call(
          fronthubInstance.delegates,
          delegateName,
        )
      ) {
        // eslint-disable-next-line no-param-reassign
        fronthubInstance.delegates[delegateName] = delegate
      }
      // free up deferred
      if (
        Object.prototype.hasOwnProperty.call(
          fronthubInstance.deferredDelegates,
          delegateName,
        )
      ) {
        fronthubInstance.deferredDelegates[
          delegateName
        ].forEach(([actor, payload]) => mediate(actor, payload, delegate))
        delete fronthubInstance.deferredDelegates[delegateName]
      }
    },
    addEventListener(eventName, callback) {
      if (
        !Object.prototype.hasOwnProperty.call(
          fronthubInstance.listeners,
          eventName,
        )
      ) {
        // eslint-disable-next-line no-param-reassign
        fronthubInstance.listeners[eventName] = []
      }
      fronthubInstance.listeners[eventName].push(callback)
    },
  }
}
